import styles from '../css/bottomsBar.module.css'
import { BsHouseDoor } from "react-icons/bs";
import { GoSearch } from "react-icons/go";
import { MdAdd } from "react-icons/md";
import { PiCoffeeDuotone } from "react-icons/pi";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { TiWeatherPartlySunny } from "react-icons/ti";
import { Link, useLocation } from 'react-router-dom';


function BottomsBar ({ onAddClick, onSearchClick, activeTab}){

  const location = useLocation();
  const isMainPage = location.pathname === '/';
  const isInfoPage = location.pathname ==='/info'
  const isAboutMePage = location.pathname ==='/info/o-mnie'
  const isCoffeePage = location.pathname === '/info/postaw-kawe';
  const isWeatherPage = location.pathname === '/weatherPage';

  const typeTab = activeTab === 'trips' ? 'trip' : 'hike'

  return(
    <>

      <div className={`${styles['bottom-bar']} userSelectNone`}>

      {isMainPage ? 
      <>
        <button className={styles.iconButton} onClick={onSearchClick}>
          <GoSearch size={24}/>
          <span>Szukaj</span>
        </button>
      </>:
      <>
       <Link to="/" className={styles.iconButton}>
          <BsHouseDoor size={24}/>
          <span>Główna</span>
        </Link>
      </>
      }
      
      
      {isMainPage &&
    
       <button 
          className={styles.iconButton}  
          onClick={() => { onAddClick(typeTab) }}>
          <MdAdd size={24}
        />
          <span>{activeTab === 'trips' ? 'Dodaj przejazd': 'Dodaj wyprawę'}</span>
        </button>
            
      }


      {isMainPage &&(
        <Link to="/pogoda" className={styles.iconButton}>
        <TiWeatherPartlySunny size={24}/>
        <span>Pogoda</span>
      </Link>)
      }
      

      {( isInfoPage || isAboutMePage  )?(
      <Link to="/info/postaw-kawe" className={styles.iconButton}>
        <PiCoffeeDuotone size={24}/>
        <span>Wesprzyj</span>
      </Link>
      ):null
      }
    

       {( !isWeatherPage  )?(
      <Link to="/info" className={styles.iconButton}>
        <BiDotsHorizontalRounded size={24}/>
        <span>Więcej</span>
      </Link>
       ):null
       }
    

    </div>

    </>
  )
}

export default BottomsBar